import axios from 'axios';

// Get the configured axios instance 
let axiosInstance;

// Initialize function to set up axios with store
export const setupApiRequestService = (store) => {
  axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_BASE_API || 'http://localhost:3000',
    headers: {
      'Content-Type': 'application/json'
    }
  });

  // Add request interceptor to include auth token from store
  axiosInstance.interceptors.request.use(
    (config) => {
      const state = store.getState();
      const token = state.auth.authToken;
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
};

const BASE_URL = '/api-requests';

const apiRequestService = {
  // Get all API requests for current user
  getApiRequests: () => {
    if (!axiosInstance) {
      throw new Error('ApiRequestService not initialized. Call setupApiRequestService first.');
    }
    return axiosInstance.get(BASE_URL);
  },

  // Submit new API request
  submitApiRequest: (data) => {
    if (!axiosInstance) {
      throw new Error('ApiRequestService not initialized. Call setupApiRequestService first.');
    }
    return axiosInstance.post(BASE_URL, data);
  },

  // Get API request by ID
  getApiRequestById: (id) => {
    if (!axiosInstance) {
      throw new Error('ApiRequestService not initialized. Call setupApiRequestService first.');
    }
    return axiosInstance.get(`${BASE_URL}/${id}`);
  },

  // Update API request status (for admin)
  updateApiRequestStatus: (id, status, reason = null) => {
    if (!axiosInstance) {
      throw new Error('ApiRequestService not initialized. Call setupApiRequestService first.');
    }
    return axiosInstance.patch(`${BASE_URL}/${id}/status`, { status, reason });
  },

  // Delete API request (Admin only)
  deleteApiRequest: (id) => {
    if (!axiosInstance) {
      throw new Error('ApiRequestService not initialized. Call setupApiRequestService first.');
    }
    return axiosInstance.delete(`${BASE_URL}/${id}`);
  },

  // Revoke API request (User can revoke their own request)
  revokeApiRequest: (id) => {
    if (!axiosInstance) {
      throw new Error('ApiRequestService not initialized. Call setupApiRequestService first.');
    }
    return axiosInstance.patch(`${BASE_URL}/${id}/revoke`);
  }
};

export default apiRequestService;
